import type { RootState } from 'src/redux';

import { selectFlags } from './select-flags';

export const selectShouldExposeConfigurableViewCount = (state: RootState) =>
  !!selectFlags(state)['configurable-view-count'];
